var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9984 141.598C118.496 141.598 141.598 118.496 141.598 89.9984C141.598 61.5005 118.496 38.3984 89.9984 38.3984C61.5005 38.3984 38.3984 61.5005 38.3984 89.9984C38.3984 118.496 61.5005 141.598 89.9984 141.598Z",
    fill: "url(#paint0_radial_8680_3918)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.608 84.483L95.5154 51.3904C92.4693 48.3443 87.5307 48.3443 84.4846 51.3904L51.392 84.483C48.3459 87.5291 48.3459 92.4678 51.392 95.5139L84.4846 128.606C87.5307 131.653 92.4693 131.653 95.5154 128.606L128.608 95.5139C131.654 92.4678 131.654 87.5291 128.608 84.483Z",
    stroke: "#F5F5F7",
    strokeOpacity: 0.09,
    strokeWidth: 1.02
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.418 82.9417L97.0598 40.5832C93.1608 36.6842 86.8392 36.6842 82.9402 40.5832L40.5817 82.9417C36.6827 86.8407 36.6827 93.1622 40.5817 97.0612L82.9402 139.42C86.8392 143.319 93.1608 143.319 97.0598 139.42L139.418 97.0612C143.317 93.1622 143.317 86.8407 139.418 82.9417Z",
    stroke: "#C1F700",
    strokeOpacity: 0.34,
    strokeWidth: 0.9216
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.684 81.6139L98.3835 31.3131C93.7534 26.6831 86.2466 26.6831 81.6165 31.3131L31.3158 81.6139C26.6857 86.2439 26.6857 93.7508 31.3158 98.3808L81.6165 148.682C86.2466 153.312 93.7534 153.312 98.3835 148.682L148.684 98.3808C153.314 93.7508 153.314 86.2439 148.684 81.6139Z",
    stroke: "#C1F700",
    strokeOpacity: 0.18,
    strokeWidth: 1.0032
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0931 25.1941C90.9428 25.1941 91.6316 24.5053 91.6316 23.6556C91.6316 22.806 90.9428 22.1172 90.0931 22.1172C89.2435 22.1172 88.5547 22.806 88.5547 23.6556C88.5547 24.5053 89.2435 25.1941 90.0931 25.1941Z",
    fill: "#C1F700"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.493 37.8147C110.255 37.8147 110.873 37.1968 110.873 36.4347C110.873 35.6725 110.255 35.0547 109.493 35.0547C108.731 35.0547 108.113 35.6725 108.113 36.4347C108.113 37.1968 108.731 37.8147 109.493 37.8147Z",
    fill: "#FF6B35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.937 46.0534C127.787 46.0534 128.475 45.3647 128.475 44.515C128.475 43.6653 127.787 42.9766 126.937 42.9766C126.087 42.9766 125.398 43.6653 125.398 44.515C125.398 45.3647 126.087 46.0534 126.937 46.0534Z",
    fill: "#C1F700"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.36 62.885C140.123 62.885 140.74 62.2672 140.74 61.505C140.74 60.7428 140.123 60.125 139.36 60.125C138.598 60.125 137.98 60.7428 137.98 61.505C137.98 62.2672 138.598 62.885 139.36 62.885Z",
    fill: "#FF6B35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.671 80.6941C153.521 80.6941 154.21 80.0053 154.21 79.1556C154.21 78.306 153.521 77.6172 152.671 77.6172C151.822 77.6172 151.133 78.306 151.133 79.1556C151.133 80.0053 151.822 80.6941 152.671 80.6941Z",
    fill: "#C1F700"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M146.134 101.283C146.896 101.283 147.514 100.666 147.514 99.9034C147.514 99.1413 146.896 98.5234 146.134 98.5234C145.372 98.5234 144.754 99.1413 144.754 99.9034C144.754 100.666 145.372 101.283 146.134 101.283Z",
    fill: "#FF6B35"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M139.36 119.877C140.123 119.877 140.74 119.259 140.74 118.497C140.74 117.735 140.123 117.117 139.36 117.117C138.598 117.117 137.98 117.735 137.98 118.497C137.98 119.259 138.598 119.877 139.36 119.877Z",
    fill: "#9B5DE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.638 135.049C127.4 135.049 128.018 134.431 128.018 133.669C128.018 132.907 127.4 132.289 126.638 132.289C125.876 132.289 125.258 132.907 125.258 133.669C125.258 134.431 125.876 135.049 126.638 135.049Z",
    fill: "#FF6B35"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.824 151.444C112.673 151.444 113.362 150.755 113.362 149.906C113.362 149.056 112.673 148.367 111.824 148.367C110.974 148.367 110.285 149.056 110.285 149.906C110.285 150.755 110.974 151.444 111.824 151.444Z",
    fill: "#C1F700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0011 148.377C90.7632 148.377 91.3811 147.759 91.3811 146.997C91.3811 146.235 90.7632 145.617 90.0011 145.617C89.2389 145.617 88.6211 146.235 88.6211 146.997C88.6211 147.759 89.2389 148.377 90.0011 148.377Z",
    fill: "#FF6B35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3588 151.444C69.2084 151.444 69.8972 150.755 69.8972 149.906C69.8972 149.056 69.2084 148.367 68.3588 148.367C67.5091 148.367 66.8203 149.056 66.8203 149.906C66.8203 150.755 67.5091 151.444 68.3588 151.444Z",
    fill: "#C1F700"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3605 135.049C54.1226 135.049 54.7405 134.431 54.7405 133.669C54.7405 132.907 54.1226 132.289 53.3605 132.289C52.5983 132.289 51.9805 132.907 51.9805 133.669C51.9805 134.431 52.5983 135.049 53.3605 135.049Z",
    fill: "#FF6B35"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0619 113.507C31.9115 113.507 32.6003 112.818 32.6003 111.968C32.6003 111.118 31.9115 110.43 31.0619 110.43C30.2122 110.43 29.5234 111.118 29.5234 111.968C29.5234 112.818 30.2122 113.507 31.0619 113.507Z",
    fill: "#C1F700"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5111 80.6941C28.3608 80.6941 29.0495 80.0053 29.0495 79.1556C29.0495 78.306 28.3608 77.6172 27.5111 77.6172C26.6614 77.6172 25.9727 78.306 25.9727 79.1556C25.9727 80.0053 26.6614 80.6941 27.5111 80.6941Z",
    fill: "#C1F700"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6378 62.885C41.4 62.885 42.0178 62.2672 42.0178 61.505C42.0178 60.7428 41.4 60.125 40.6378 60.125C39.8757 60.125 39.2578 60.7428 39.2578 61.505C39.2578 62.2672 39.8757 62.885 40.6378 62.885Z",
    fill: "#FF6B35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2455 43.0534C50.0951 43.0534 50.7839 42.3647 50.7839 41.515C50.7839 40.6653 50.0951 39.9766 49.2455 39.9766C48.3958 39.9766 47.707 40.6653 47.707 41.515C47.707 42.3647 48.3958 43.0534 49.2455 43.0534Z",
    fill: "#C1F700"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.505 37.8147C71.2672 37.8147 71.885 37.1968 71.885 36.4347C71.885 35.6725 71.2672 35.0547 70.505 35.0547C69.7428 35.0547 69.125 35.6725 69.125 36.4347C69.125 37.1968 69.7428 37.8147 70.505 37.8147Z",
    fill: "#FF6B35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.608 84.483L95.5154 51.3904C92.4693 48.3443 87.5307 48.3443 84.4846 51.3904L51.392 84.483C48.3459 87.5291 48.3459 92.4678 51.392 95.5139L84.4846 128.606C87.5307 131.653 92.4693 131.653 95.5154 128.606L128.608 95.5139C131.654 92.4678 131.654 87.5291 128.608 84.483Z",
    stroke: "#C1F700",
    strokeWidth: 0.9
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6016 90.6031L84.3016 102.303L107.402 77.7031",
    stroke: "#C1F700",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8859 51.7031C28.4879 54.0442 29.2237 54.78 31.5648 55.382C29.2237 55.984 28.4879 56.7198 27.8859 59.0609C27.2839 56.7198 26.5481 55.984 24.207 55.382C26.5481 54.78 27.2839 54.0442 27.8859 51.7031Z",
    fill: "#C1F700"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.601 53.6953C149.043 55.4173 149.585 55.9585 151.307 56.4013C149.585 56.8441 149.043 57.3853 148.601 59.1073C148.158 57.3853 147.617 56.8441 145.895 56.4013C147.617 55.9585 148.158 55.4173 148.601 53.6953Z",
    fill: "#FF6B35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M140.612 128.055C141.154 130.162 141.816 130.824 143.923 131.366C141.816 131.907 141.154 132.57 140.612 134.677C140.07 132.57 139.408 131.907 137.301 131.366C139.408 130.824 140.07 130.162 140.612 128.055Z",
    fill: "#C1F700"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4029 130.164C38.8025 131.718 39.2909 132.206 40.8449 132.606C39.2909 133.006 38.8025 133.494 38.4029 135.048C38.0033 133.494 37.5149 133.006 35.9609 132.606C37.5149 132.206 38.0033 131.718 38.4029 130.164Z",
    fill: "#FF6B35"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8680_3918",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.9984 89.9984) scale(51.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1F700",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C1F700",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1F700",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassSuccessIcon);
export default __webpack_public_path__ + "static/media/pass-success-icon.a07119d9a91f8b28492d5b642b3ba05b.svg";
export { ForwardRef as ReactComponent };